CustomTC.define('jquery/var/support',[],function() {
	// All support tests are defined in their respective modules.
	return {};
});

